import React from 'react';
import { TableFilter } from 'components/UI/Table';

/**
 * Хук для автоматического сброса пагинации при изменении фильтра (кроме сортировки)
 * @param filter - текущий фильтр
 * @param resetOffset - функция сброса offset из usePaginate
 */
export function useFilterPagination(filter: TableFilter, resetOffset: () => void) {
	const filterWithoutSort = React.useMemo(() => {
		const { sortKey, sortDirection, ...rest } = filter;
		return JSON.stringify(rest);
	}, [filter]);

	React.useEffect(() => {
		resetOffset();
	}, [filterWithoutSort, resetOffset]);
}
